// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags_rZT5x {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  flex-direction: row !important;
  width: 90%;
  .tag__lsrv {
    color: var(--white-color);
    padding: 0px 4px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    cursor: pointer;
    width: fit-content;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Tags/Tags.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,UAAU;EACV;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".tags {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  flex-direction: row !important;\n  width: 90%;\n  .tag {\n    color: var(--white-color);\n    padding: 0px 4px;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    cursor: pointer;\n    width: fit-content;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tags": `tags_rZT5x`,
	"tag": `tag__lsrv`
};
export default ___CSS_LOADER_EXPORT___;
